import Skelet from '../Skelet';
import styles from '../../styles/modules/mortgage/MortgageCalculatorItem.module.scss';

const MortgageCalculatorSkeletonItem = () => {
  return (
    <div className={styles.mortgage}>
      <div className={styles.mortgageMain}>
        <div className={styles.mortgageBlock}>
          <Skelet className={styles.mortgageIcon} style={{ borderRadius: '50%' }} />
          <Skelet className={styles.mortgageTitle} width={150} height={25} />
        </div>
        <div className={styles.mortgageBlock}>
          <div className={styles.mortgageGroup}>
            <Skelet className={styles.mortgageGroupTitle} width={50} />
            <Skelet className={styles.mortgageGroupText} height={20} />
          </div>
          <div className={styles.mortgageGroup}>
            <Skelet className={styles.mortgageGroupTitle} width={50} />
            <Skelet className={styles.mortgageGroupText} height={20} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MortgageCalculatorSkeletonItem;
